import PropTypes from "prop-types";

export const SoundBoxWorkItem = ({
  image,
  titleheader,
  title,
  check,
  width,
}) => {
  return (
    <div
      className={` ${check ? width : "max-w-[426px] lgmax:max-w-none"}  groupHover group flex flex-col gap-[20px] px-[20px] py-[10px] sm:px-0`}
    >
      <img
        className="h-[152px] w-[200px] group-hover:animate-hover"
        src={image}
        alt=""
      />

      <div className="flex flex-col gap-[10px]">
        <h3 className="hoverText    bg-[-100%] text-[20px] font-bold text-[--color-hover] group-hover:animate-text group-hover:bg-[0] group-hover:text-[#2B1C50]">
          {titleheader}
        </h3>
        <div className="h-[4px] max-w-[260px] bg-[#565ADD] group-hover:bg-[#2B1C50]"></div>
        <p className="text-4 hoverTextChild font-normal text-[--color-text]">
          {" "}
          {title}
        </p>
      </div>
    </div>
  );
};
SoundBoxWorkItem.propTypes = {
  image: PropTypes.string,
  titleheader: PropTypes.string,
  title: PropTypes.string,
  check: PropTypes.bool,
  width: PropTypes.string,
};
